import React from 'react';
import { CtaButton } from './CtaButton';
import { TrustStrip } from './TrustStrip';
import { pricing } from '../data/unstuckContent';
export function MidPageCta() {
  return <section className="w-full border-y border-champagne/25 bg-charcoal-950 py-12 sm:py-14" aria-labelledby="mid-cta-title" data-id="element-135" data-mp="3jlle6sc068m">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-136" data-mp="8hn8d2svoppd">
        <h2 id="mid-cta-title" className="font-display text-[1.5rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2rem]" data-id="element-137" data-mp="37xtmotmnorcb">
          You already know what has to change.
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-[14px] leading-relaxed text-body sm:text-[15px]" data-id="element-138" data-mp="3gy8g6g9rxcqw">
          This is the system that makes you do it — 6 volumes, 5 bonuses, and your first
          execution sprint starting today.
        </p>

        <p className="mt-6 text-[12px] uppercase tracking-[0.12em] text-muted" data-id="element-139" data-mp="wadg0ztr0mtu">
          <span className="line-through" data-id="element-140" data-mp="115ssbnc3yao5">{pricing.regularPrice}</span>
          <span className="ml-3 font-semibold text-champagne" data-id="element-141" data-mp="1cfvg472ogmx9">
            Today {pricing.today} USD
          </span>
        </p>

        <div className="mt-5 flex justify-center" data-id="element-142" data-mp="18ei6dlwgrzl2">
          <CtaButton size="md" label="I want my UNSTUCK now →" data-id="element-143" data-mp="13enjrujq1w5t" />
        </div>
        <TrustStrip className="mt-3" data-id="element-144" data-mp="13gqdaok327fa" />
      </div>
    </section>;
}